import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import UpdateCustomer from "./UpdateCustomers";
import DeletedCustomer from "./DeleteCustomers";
import ViewCustomer from "./ViewCustomer";

const server_backend = config.API_URL;

const Customers = ({ username }) => {
    const [CustomerList, setCustomerList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [viewBCustomer, setViewBCustomer] = useState(false);
    const [currentCustomer, setCurrentCustomer] = useState(0);
    const [updatting, setIsUpdatting] = useState(false);

    useEffect(() => {
        const getCustomers = async () => {
            try {
                const response = await axios.get(`${server_backend}/Customers/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setCustomerList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getCustomers();
    }, []);

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModal = () => {
        setIsUpdating(false);
    }

    const getCustomers = async () => {
        try {
            const response = await axios.get(`${server_backend}/Customers/list`, headers);

            if (response.data.RES_CODE === "00") {
                setCustomerList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };


    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {
        try {
            const response = await axios.get(`${server_backend}/Customers/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setCustomerList(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);

    const showViewCustomer = () => {
        setViewBCustomer(true);
    }

    const CloseViewCustomer = () => {
        setViewBCustomer(false);
    }

    const ShowModalCustomerUpdate = () => {
        setIsUpdatting(true);
    }
    const CloseModalCustomerUpdate = () => {
        setIsUpdatting(false);
    }

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            {viewBCustomer ? (
                <ViewCustomer username={username} customerID={currentCustomer} CloseViewCustomer={CloseViewCustomer} />
            ) : (
                <div>
                    {updatting ? (
                        <UpdateCustomer username={username} onCustomerID={currentCustomer} onClose={CloseModalCustomerUpdate} />
                    ) : (
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Customers List</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Customers</a></li>
                                                <li className="breadcrumb-item active">Customers List</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card" id="tasksList">
                                        <div className="card-header border-0">
                                            <div className="d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">All Customers</h5>
                                                <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                    <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                        <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                    </button>
                                                </div>
                                                <div className="flex-shrink-0">
                                                    <Link className="btn btn-danger add-btn" to="/create-customer">
                                                        <i className="ri-add-line align-bottom me-1"></i> Create
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        {filtersEnabled && (
                                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                                <div className="row g-3">
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                disabled={!filtersEnabled}
                                                                value={filterBy}
                                                                onChange={handleFilterByChange}
                                                            >
                                                                <option value="">Filter by</option>
                                                                <option value="cust_ID">ID</option>
                                                                <option value="fullname">Full name</option>
                                                                <option value="email">Email</option>
                                                                <option value="phone">Phone</option>
                                                                <option value="city">City</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                data-choices
                                                                data-choices-search-false
                                                                name="choices-single-default"
                                                                id="idFilterStatus"
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterStatusChange}
                                                            >
                                                                <option value={0}>Filter status</option>
                                                                <option value={1}>ACTIVATED</option>
                                                                <option value={2}>DISABLED</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="search-box">
                                                            <input
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder="Search for tasks or something..."
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterValueChange}
                                                            />
                                                            <i className="ri-search-line search-icon"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="card-body">
                                        <div
  className="table-responsive table-card mb-4"
  style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
>
                                        <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                    <thead className="table-light text-muted">
                                                        <tr>
                                                            <th className="th-hover" onClick={() => handleColumnClick("name")}>ID</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("fullname")}>Full name</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("email")}>Email</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("phone")}>Phone</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("phone2")}>Phone 2</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("status")}>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="list form-check-all">
                                                        {CustomerList.map((Customers_L) => (
                                                            <tr key={Customers_L.cust_ID}>
                                                                <th scope="row">
                                                                    <div className="form-check">
                                                                        {Customers_L.cust_ID}
                                                                    </div>
                                                                </th>
                                                                <td className="client_name">{Customers_L.fullname}</td>
                                                                <td className="client_name">{Customers_L.email}</td>
                                                                <td className="assignedto">
                                                                    {Customers_L.phone}
                                                                </td>
                                                                <td className="assignedto">
                                                                    {Customers_L.phone2}
                                                                </td>
                                                                <td className="status">
                                                                    <span className={`${Customers_L.status_name === 'ACTIVATED' ? "badge badge-soft-success" : "badge badge-soft-danger"} text-uppercase`}>
                                                                        {Customers_L.status_name}
                                                                    </span>
                                                                </td>
                                                                <td className="due_date">
                                                                    <ul className="list-inline hstack gap-2 mb-0">

                                                                        <li className="list-inline-item" >
                                                                            <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                                setCurrentCustomer(Customers_L.cust_ID);
                                                                                showViewCustomer()
                                                                            }}>
                                                                                <i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                            </Link>
                                                                        </li>
                                                                        <li className="list-inline-item edit">
                                                                            <Link
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    setCurrentCustomer(Customers_L.cust_ID);
                                                                                    ShowModalCustomerUpdate();
                                                                                }}
                                                                                className="text-primary d-inline-block edit-item-btn"
                                                                            >
                                                                                <i className="ri-pencil-fill fs-16"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row g-0 text-center text-sm-start">
                                                <div className="col-sm-6">
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Customers;
